import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { PermisosAccionesAtestFitoViewModel } from '../permisosaccionesatestfito.types';
import { FormGroup } from '@angular/forms';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';

@Component({
    selector: 'app-permisosaccionesatestfito-edit',
    templateUrl: './permisosaccionesatestfito-edit.component.html',
})
export class PermisosAccionesAtestFitoEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() permisoAccionAtestFito: PermisosAccionesAtestFitoViewModel;
    @Input() formGroup: FormGroup;
    @Input() listAcciones: Tc[];
    @Input() listPerfiles: Tc[];
    @Input() listEstadosAtestFito: Tc[];
    @Input() listTiposAtestFito: Tc[];

    isCollapsedCabecera = false;

    constructor(protected notificationService: NotificationService, protected authService: AuthService, protected exceptionHandler: ExceptionManager) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.permisoAccionAtestFito?.currentValue) {
            this.permisoAccionAtestFito = { ...changes.permisoAccionAtestFito?.currentValue };
            this.updateForm();
        }
    }

    private updateForm(): void {
        this.formGroup.setValue({
            Id: this.permisoAccionAtestFito?.Id || null, // Not visible but required
            IdAccion: this.permisoAccionAtestFito?.IdAccion || null,
            IdPerfil: this.permisoAccionAtestFito?.IdPerfil || null,
            IdEstadoAtestFito: this.permisoAccionAtestFito?.IdEstadoAtestFito || null,
            IdTipoAtestFito: this.permisoAccionAtestFito?.IdTipoAtestFito || null,
            Edicion: this.permisoAccionAtestFito?.Edicion || false,
        });

        this.form = this.formGroup;
    }
}
